import {makeStyles} from "@material-ui/core/styles";

const tahunAjaranStyles = makeStyles((theme) => ({
  dialogArrowList: {
    minWidth: theme.spacing(4)
  }
}))

export default tahunAjaranStyles